import React from 'react';
import { useSyncNotificationBadgeCount } from '@/hooks/use-sync-notification-badge-count';

interface Props {
  children?: React.ReactNode;
}

export const NotificationBadgeCountContainer: React.FC<Props> = ({
  children,
}) => {
  useSyncNotificationBadgeCount();

  return <>{children}</>;
};
